import type { CSSProperties, SyntheticEvent } from "react";

export interface AudioPlayerAdapterProps {
  src: string;
  controls?: boolean;
  width?: number | string;
  showDownloadButton?: boolean;
  className?: string;
  preload?: "auto" | "metadata" | "none";
  onError?: (event: SyntheticEvent<HTMLAudioElement, Event>) => void;
}

function resolveWidthStyle(width: AudioPlayerAdapterProps["width"]): CSSProperties | undefined {
  if (width === undefined) {
    return undefined;
  }

  return {
    width: typeof width === "number" ? `${width}px` : width,
  };
}

export function AudioPlayerAdapter({
  src,
  controls = false,
  width,
  className,
  preload = "metadata",
  onError,
}: AudioPlayerAdapterProps) {
  return (
    <audio
      src={src}
      controls={controls}
      className={className}
      preload={preload}
      style={resolveWidthStyle(width)}
      onError={onError}
    />
  );
}
